<template>
	<div class="content background1">
		<div class="tableBox11">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes" v-if="getTreeMes=='1'">
						<p class="title">{{$t('label_396')}}</p>
						<div class="chooseBox spaceBetween">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText" style="width: 100px;">
											<p>{{$t('label_301')}}</p>
										</div>
										<div class="select">
											<el-input v-model="searchDataList.name" clearable></el-input>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChoose" style="width: 380px">
										<div class="selectText">
											<p>{{$t('label_305')}}</p>
										</div>
										<div class="select">
											<el-select v-model="searchDataList.list" multiple collapse-tags>
												<!-- <el-option label="全部" value="-1" key="-1"></el-option> -->
												<el-option v-for="(item,index) in factoryTypeList" :label="item.val" :value="item.key" :key="item.key"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div>
									<div class="chooseButton sendButton" @click="search"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>
						<div class="spotMes2Box" :style="{'height':'calc(100% - 150px)'}">
							<div class="buttonBox" style="margin-bottom: 10px;">
								<div>
									<div class="chooseButton searchButton" @click="addFactory($t('btn_14'))" v-if="MenuRoleList.indexOf('4')>=0"><i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}</div>
									<div class="chooseButton searchButton" @click="addFactory($t('btn_15'))" v-if="MenuRoleList.indexOf('5')>=0"><i class="el-icon-edit-outline"></i>{{$t('btn_15')}}</div>
									<div class="chooseButton deleteButton" @click="factoryDel" v-if="MenuRoleList.indexOf('6')>=0"><i class="el-icon-delete"></i>{{$t('btn_16')}}</div>
<!--									<div class="chooseButton searchButton" @click="exportClick" v-if="MenuRoleList.indexOf('7')>=0"><i class="el-icon-download"></i>{{$t('btn_10')}}</div>-->
								</div>
							</div>
							<div class="tableMin" style="height: calc(100% - 100px);">
								<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row @current-change="handleCurrentChangeTree"
								 border style="width: 100%;" height="100%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
									<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
									</el-table-column>
									<el-table-column prop="name" :label="$t('label_301')" align="left">
										<template slot-scope="scope">
											<popMesBox :popMes="scope.row.name" :hoverMes="scope.row.name" :popWidth="200"></popMesBox>
										</template>
									</el-table-column>
									<el-table-column prop="contact" :label="$t('label_724')" align="left">
									</el-table-column>
									<el-table-column prop="contactPhone" :label="$t('label_569')" align="center">
									</el-table-column>
									<el-table-column prop="address" :label="$t('label_309')" align="left">
										<template slot-scope="scope">
											<popMesBox :popMes="scope.row.address" :hoverMes="scope.row.address" :popWidth="200"></popMesBox>
										</template>
									</el-table-column>
									<el-table-column prop="type" :label="$t('label_305')" align="left">
										<template slot-scope="scope">
											<template v-for="item in scope.row.type.split(',')">
												{{checkFacTypeText(item)}}
											</template>
										</template>
									</el-table-column>
									<el-table-column prop="website" :label="$t('label_312')" align="left">
										<template slot-scope="scope">
											<popMesBox :popMes="scope.row.website" :hoverMes="scope.row.website" :popWidth="200"></popMesBox>
										</template>
									</el-table-column>
								</el-table>
								<div style="position: absolute;bottom: 30px;left: 30%">
									<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
									 @parentMethod="searchPage"></Page>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<el-dialog :title="factoryDialogTitle" :visible.sync="dialogFactory" append-to-body :close-on-click-modal='false'
		 width="900px" top="10%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<div class="dialogMes">
						<p><span style="color: #ff0000">*</span>{{$t('label_301')}}</p>
						<div class="mesInput" style="width: 360px">
							<el-input v-if="factoryDialogTitle == this.$t('btn_14')" show-word-limit v-model="dialogFactoryEdit.name" maxlength="20"></el-input>
							<el-input v-if="factoryDialogTitle == this.$t('btn_15')" :disabled="true" show-word-limit v-model="dialogFactoryEdit.name" maxlength="20"></el-input>
						</div>
					</div>
					<div class="dialogMes" style="margin-left: 30px">
						<p><span style="color: #ff0000">*</span>{{$t('label_305')}}</p>
						<div class="mesInput" style="width: 215px">
							<el-select v-model="dialogFactoryEdit.type" multiple collapse-tags style="width:215px">
								<el-option v-for="(item,index) in factoryTypeList" :label="item.val" :value="item.key" :key="item.key"></el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<div class="dialogMes">
						<p>{{$t('label_309')}}</p>
						<div class="mesInput" style="width: 706px">
							<el-input maxlength="200" show- word-limit v-model="dialogFactoryEdit.address"></el-input>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<div class="dialogMes" >
						<div class="dialogMes" >
							<p>{{$t('label_312')}}</p>
							<div class="mesInput" style="width: 360px">
								<el-input v-model="dialogFactoryEdit.website"></el-input>
							</div>
						</div>
						<div class="dialogMes" style="margin-left: 30px">
							<p>{{$t('label_316')}}</p>
							<div class="mesInput">
								<el-input v-model="dialogFactoryEdit.postCode" style="width: 215px;" ></el-input>
							</div>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<p></p>
					<div class="mesSelect">
						<div>
							<div class="text" style="display: flex;width: 640px;padding-left:15px;text-align: center">
								<p style="width: 160px">{{$t('label_859')}}</p>
								<p style="width: 160px">{{$t('label_860')}}</p>
								<p style="width: 160px">{{$t('label_861')}}</p>
								<p style="width: 160px">{{$t('label_862')}}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_724')}}</p>
					<div class="mesSelect">
						<div>
							<div class="text" style="display: flex;width: 640px;">
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contact" style="width: 150px"></el-input>
								</p>
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contact1" style="width: 150px"></el-input>
								</p>
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contact2" style="width: 150px"></el-input>
								</p>
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contact3" style="width: 150px"></el-input>
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_85')}}</p>
					<div class="mesSelect">
						<div>
							<div class="text" style="display: flex;width: 640px;">
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contactPhone" style="width: 150px"></el-input>
								</p>
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contactPhone1" style="width: 150px"></el-input>
								</p>
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contactPhone2" style="width: 150px"></el-input>
								</p>
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contactPhone3" style="width: 150px"></el-input>
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_135')}}</p>
					<div class="mesSelect">
						<div>
							<div class="text" style="display: flex;width: 640px;">
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contactFax" style="width: 150px"></el-input>
								</p>
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contactFax1" style="width: 150px"></el-input>
								</p>
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contactFax2" style="width: 150px"></el-input>
								</p>
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contactFax3" style="width: 150px"></el-input>
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_328')}}</p>
					<div class="mesSelect">
						<div>
							<div class="text" style="display: flex;width: 640px;">
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contactEmail" style="width: 150px"></el-input>
								</p>
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contactEmail1" style="width: 150px"></el-input>
								</p>
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contactEmail2" style="width: 150px"></el-input>
								</p>
								<p style="width: 160px">
									<el-input v-model="dialogFactoryEdit.contactEmail3" style="width: 150px"></el-input>
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="dialogMes" style="margin-top: 10px">
					<p>{{$t('label_846')}}</p>
					<div class="mesInput" style="width: 630px">
						<el-input type="textarea" :placeholder="$t('input_46')" maxlength="100" show-word-limit v-model="dialogFactoryEdit.remark"></el-input>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<span class="buttonBox" style="justify-content: center">
					<div class="chooseButton sendButton" @click="FactoryEditSave(factoryDialogTitle)">{{$t('btn_13')}}</div>
					<div class="chooseButton searchButton" style="width: 150px" @click="handleClose">{{$t('btn_1')}}</div>
				</span>
			</span>
		</el-dialog>

		<exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList" style="width: 100%;height: 100%"
		 ref="exportBox"></exportMes>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import file from "@/assets/js/file/file.js";
	import exportMes from "@/components/list/export/export";
	import popMesBox from "@/components/list/popover/pop";

	export default {
		name: 'fileFactory',
		components: {
			Page,
			calendar,
			exportMes,
			popMesBox,
		},
		data() {
			return {
        saveLoading: false,
				pageNum: 1,
				select: 0,
				pageSize: 10,
				pageCount: 0,
				Readytime: '',
				height: 620,
				MenuRoleList: [],
				exportTitle: this.$t('label_396'),
				exportList: [{
					column: 'name',
					title: this.$t('label_301'),
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'contact',
					title: this.$t('label_724'),
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'contactPhone',
					title: this.$t('label_569'),
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'address',
					title: this.$t('label_309'),
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'type2',
					title: this.$t('label_305'),
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'website',
					title: this.$t('label_312'),
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}],
				dialogFactoryEdit: {
					address: "",
					contact: "",
					contact1: "",
					contact2: "",
					contact3: "",
					contactEmail: "",
					contactEmail1: "",
					contactEmail2: "",
					contactEmail3: "",
					contactFax: "",
					contactFax1: "",
					contactFax2: "",
					contactFax3: "",
					contactPhone: "",
					contactPhone1: "",
					contactPhone2: "",
					contactPhone3: "",
					name: "",
					postCode: "",
					remark: "",
					shortName: "",
					type: [],
					updateTime: "",
					website: ""
				},
				tableDataTreeInfo: {},
				factoryDialogTitle: this.$t('btn_14'),
				getTreeMes: '1',
				dialogFactory: false,
				searchDataList: {
					list: [],
					name: '',
					language: 'zh',
				},
				tableDataTreeTime: [],
				tableDataTreeTimeExport: [],
				tableDataTree: [],
				factoryTypeList: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
			}
		},
		methods: {
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			exportClick() {
				this.$refs.exportBox.setExportExcel();
			},
			selectProp: function(index) {
				console.log(index)
				this.select = index
			},
			handler() {

			},
			checkFacTypeText(type) {
				if (type==""||type==undefined||type==null){
					return false
				}
				var data = this.factoryTypeList.filter(function(item) {
					return item.key == type;
				})
				if (data.length > 0 && data[0].val) {
					return data[0].val
				}
			},
			addFactory(title) {
				this.factoryDialogTitle = title;
				if (title != this.$t('btn_14')) {
					if (Object.keys(this.tableDataTreeInfo).length > 0) {
						let param = {
							id: this.tableDataTreeInfo.id,
							Language: 'zh'
						}
						file.saveEquipmentFirmSelectById(param).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.dialogFactory = true;
								this.dialogFactoryEdit = data.data
								this.dialogFactoryEdit.type = this.dialogFactoryEdit.type.split(',')
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					} else {
						utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
					}
				} else {
					this.dialogFactory = true;
				}
			},
			handleClose() {
				this.dialogFactory = false;
				this.dialogFactoryEdit = {
					address: "",
					contact: "",
					contact1: "",
					contact2: "",
					contact3: "",
					contactEmail: "",
					contactEmail1: "",
					contactEmail2: "",
					contactEmail3: "",
					contactFax: "",
					contactFax1: "",
					contactFax2: "",
					contactFax3: "",
					contactPhone: "",
					contactPhone1: "",
					contactPhone2: "",
					contactPhone3: "",
					name: "",
					postCode: "",
					remark: "",
					shortName: "",
					type: [],
					updateTime: "",
					website: ""
				}
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			handleCurrentChangeTreeTime(info) {},
			searchPage(param) {
				var dataParam = this.searchDataList;
				var newParam = Object.assign(param, dataParam);
				this.exportEquipmentFirm(newParam);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				this.getEquipmentFirm(newParam);
			},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize
				}
				this.searchPage(param);
			},
			getEquipmentFirm(param) {
				file.getEquipmentFirm(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTime = data.data.records;
						this.pageCount = data.data.total;
						this.pageSize = data.data.size;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			exportEquipmentFirm(param) {
				file.exportEquipmentFirm(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTimeExport = data.data;
						for (var i = 0; i < this.tableDataTreeTimeExport.length; i++) {
							let list = this.tableDataTreeTimeExport[i].type.split(',');
							var text = '';
							for (var q = 0; q < list.length; q++) {
								text += this.checkFacTypeText(list[q]) + ' '
							}
							this.tableDataTreeTimeExport[i].type = text;
						}
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getFactoryTypeList() {
			  console.log('file', sessionStorage.getItem("languageType"))
        file.getByDictIdALL({dictId: 1, languageType: sessionStorage.getItem("languageType")}).then((response) => {
          const data = response.data;
          if (data.code == "1") {
            this.factoryTypeList = data.data
          }
        }).catch((response) => {
          console.log(response)
        });
				// file.getFactoryTypeList({dictId: 1, languageType: languageType}).then((response) => {
				// 	const data = response.data;
				// 	if (data.code == "1") {
				// 		this.factoryTypeList = data.data
				// 	}
				// }).catch((response) => {
				// 	console.log(response)
				// })
			},
			FactoryEditSave() {
        this.saveLoading = true;
				if (this.factoryDialogTitle == this.$t('btn_14')) {
					if (this.dialogFactoryEdit.name == '' || this.dialogFactoryEdit.name == null) {
						utils.messageAlert(this.$t('input_111'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
						return;
					}
					if (this.dialogFactoryEdit.type == '' || this.dialogFactoryEdit.type == null) {
						utils.messageAlert(this.$t('input_110'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
						return;
					}
					if (this.dialogFactoryEdit.address == '' || this.dialogFactoryEdit.address == null) {
						utils.messageAlert(this.$t('input_109'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
						return;
					}
					if (this.dialogFactoryEdit.postCode == '' || this.dialogFactoryEdit.postCode == null) {
						utils.messageAlert(this.$t('input_108'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
						return;
					}
					// if (this.dialogFactoryEdit.website == '' || this.dialogFactoryEdit.website == null) {
					// 	utils.messageAlert('请填写网址', this.$t('label_358'), this.$t('label_100'));
					// 	return;
					// }
					file.saveEquipmentFirmInsert(this.dialogFactoryEdit).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchDataList.name = this.dialogFactoryEdit.name;
							this.search();
							this.$message({
								message: this.$t('msg_18'),
								type: 'success'
							});
							this.dialogFactory = false;
							this.dialogFactoryEdit = {
								address: "",
								contact: "",
								contact1: "",
								contact2: "",
								contact3: "",
								contactEmail: "",
								contactEmail1: "",
								contactEmail2: "",
								contactEmail3: "",
								contactFax: "",
								contactFax1: "",
								contactFax2: "",
								contactFax3: "",
								contactPhone: "",
								contactPhone1: "",
								contactPhone2: "",
								contactPhone3: "",
								name: "",
								postCode: "",
								remark: "",
								shortName: "",
								type: [],
								updateTime: "",
								website: ""
							}
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
						this.$message({
							message: this.$t('msg_77'),
							type: 'error'
						});
            this.saveLoading = false;
					})
				} else {
					file.saveEquipmentFirmUpdate(this.dialogFactoryEdit).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchDataList.name = this.dialogFactoryEdit.name;
							this.search();
							this.$message({
								message: this.$t('msg_21'),
								type: 'success'
							});
							this.dialogFactory = false;
							this.dialogFactoryEdit = {
								address: "",
								contact: "",
								contact1: "",
								contact2: "",
								contact3: "",
								contactEmail: "",
								contactEmail1: "",
								contactEmail2: "",
								contactEmail3: "",
								contactFax: "",
								contactFax1: "",
								contactFax2: "",
								contactFax3: "",
								contactPhone: "",
								contactPhone1: "",
								contactPhone2: "",
								contactPhone3: "",
								name: "",
								postCode: "",
								remark: "",
								shortName: "",
								type: [],
								updateTime: "",
								website: ""
							}
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
						this.$message({
							message: this.$t('msg_77'),
							type: 'error'
						});
            this.saveLoading = false;
					})
				}
			},
			factoryDel() {
				let param = this.tableDataTreeInfo.id;
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
						confirmButtonText: this.$t('label_100'),
						cancelButtonText: this.$t('btn_1'),
						type: 'warning'
					}).then(() => {
						file.delEquipmentFirm(param).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.search();
								this.$message({
									message: this.$t('msg_14'),
									type: 'success'
								});
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {

					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			}
		},
		created() {
			this.MenuRoleList = this.$store.getters.getMenu;
			this.search();
			this.getFactoryTypeList();
		}
	}
</script>

<style scoped>
    .buttonBox .chooseButton{
        margin-left: 1px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/file/fileFactory.vue